import { LOCATION_SIDEBAR } from './locationSidebar';

export const AI_CREATE_LOCATION_TEMPLATE = `
<div class="flex h-screen overflow-hidden">
<!-- Sidebar -->
${LOCATION_SIDEBAR}
<!-- Main Content -->
<main class="ml-64 flex-1 flex flex-col min-w-0 bg-background-light dark:bg-background-dark overflow-y-auto">
<!-- Top Header -->
<header class="h-16 border-b border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-background-dark/80 backdrop-blur flex items-center justify-between px-8 shrink-0 sticky top-0 z-10">
<div class="flex items-center gap-2 text-sm text-slate-500">
<a class="hover:text-primary transition-colors" href="/locations">Locations</a>
<span class="material-symbols-outlined text-xs">chevron_right</span>
<span class="text-slate-900 dark:text-slate-100 font-medium">AI Location Generator</span>
</div>
<div class="flex items-center gap-4">
<button class="p-2 text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors relative">
<span class="material-symbols-outlined">notifications</span>
<span class="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full border-2 border-white dark:border-background-dark"></span>
</button>
<div class="h-6 w-[1px] bg-slate-200 dark:border-slate-800"></div>
<button class="flex items-center gap-2 px-3 py-1.5 bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 rounded-lg text-sm font-medium">
<span class="material-symbols-outlined text-sm">help</span>
                    Docs
                </button>
</div>
</header>
<!-- Form Content -->
<div class="flex-1 p-8">
<div class="max-w-6xl mx-auto">
<div class="mb-8">
<h2 class="text-3xl font-extrabold text-slate-900 dark:text-white tracking-tight">AI Location Generator</h2>
<p class="text-slate-500 mt-2 text-lg">Convert messy descriptions, blog posts, or Google Maps URLs into structured data.</p>
</div>
<div class="grid grid-cols-1 lg:grid-cols-12 gap-8">
<!-- Input Section -->
<div class="lg:col-span-5 space-y-6">
<div class="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-6 shadow-sm">
<label class="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-3 uppercase tracking-wider">Source Information</label>
<textarea id="ai-location-source" class="w-full h-64 bg-slate-50 dark:bg-slate-950 border-slate-200 dark:border-slate-800 rounded-lg focus:ring-primary focus:border-primary transition-all text-sm resize-none placeholder:text-slate-400 p-4" placeholder="Example: There's a beautiful overlook at the top of the Grossglockner High Alpine Road in Austria. It has a great cafe and plenty of bike parking. Coordinates are roughly 47.07, 12.75..."></textarea>
<div class="mt-4 flex items-center justify-between">
<span class="text-[11px] text-slate-400 font-medium">Supported: URLs, Text, Coordinates</span>
<button id="ai-location-generate-btn" class="bg-primary hover:bg-primary/90 text-white px-6 py-2.5 rounded-lg font-bold text-sm shadow-lg shadow-primary/20 transition-all flex items-center gap-2" type="button">
<span class="material-symbols-outlined text-lg">auto_awesome</span>
                                    Generate Data
                                </button>
</div>
</div>
<!-- Info Card -->
<div class="bg-primary/5 border border-primary/20 rounded-xl p-4 flex gap-4">
<span class="material-symbols-outlined text-primary">info</span>
<p class="text-sm text-primary/80 leading-relaxed">
<strong>Tip:</strong> Provide a direct Google Maps URL for the highest accuracy in coordinate and tag extraction.
                            </p>
</div>
</div>
<!-- Result Section -->
<div class="lg:col-span-7 space-y-6">
<div class="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm flex flex-col h-full min-h-[500px]">
<!-- Header -->
<div class="p-6 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
<h3 class="font-bold text-slate-900 dark:text-white flex items-center gap-2">
<span class="material-symbols-outlined text-primary">analytics</span>
                                    AI Preview
                                </h3>
<span id="ai-location-status" class="px-2 py-1 bg-green-100 text-green-700 text-[10px] font-bold rounded uppercase tracking-widest">Ready to review</span>
</div>
<!-- Data Display -->
<div class="p-6 space-y-6 flex-1">
<div class="grid grid-cols-1 md:grid-cols-2 gap-6">
<div class="col-span-2 md:col-span-1">
<label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">Title</label>
<p id="ai-location-title" class="text-slate-900 dark:text-white font-semibold">Grossglockner Edelweißspitze Overlook</p>
</div>
<div class="col-span-2 md:col-span-1">
<label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">Slug</label>
<p id="ai-location-slug" class="font-mono text-xs bg-slate-50 dark:bg-slate-800 px-2 py-1 rounded inline-block text-primary">grossglockner-edelweisspitze-overlook</p>
</div>
</div>
<div>
<label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">Description</label>
<p id="ai-location-description" class="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                                        The highest accessible point of the Grossglockner High Alpine Road, offering a 360-degree panoramic view of more than 30 peaks over 3,000 meters. Extremely popular for motorcycle touring due to its hairpin bends and scenic vistas.
                                    </p>
</div>
<div class="grid grid-cols-1 md:grid-cols-2 gap-6 bg-slate-50 dark:bg-slate-800/50 p-4 rounded-lg">
<div>
<label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">Latitude</label>
<div class="flex items-center gap-2">
<span id="ai-location-latitude" class="text-sm font-medium">47.0700</span>
<span class="material-symbols-outlined text-green-500 text-sm">check_circle</span>
</div>
</div>
<div>
<label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">Longitude</label>
<div class="flex items-center gap-2">
<span id="ai-location-longitude" class="text-sm font-medium">12.7500</span>
<span class="material-symbols-outlined text-green-500 text-sm">check_circle</span>
</div>
</div>
</div>
<div>
<label class="block text-[10px] font-bold text-slate-400 uppercase mb-2">Suggested Tags</label>
<div id="ai-location-tags" class="flex flex-wrap gap-2">
<span class="px-3 py-1 bg-primary/10 text-primary text-xs font-semibold rounded-full border border-primary/20">#Scenic</span>
<span class="px-3 py-1 bg-primary/10 text-primary text-xs font-semibold rounded-full border border-primary/20">#Paved</span>
<span class="px-3 py-1 bg-primary/10 text-primary text-xs font-semibold rounded-full border border-primary/20">#HighAltitude</span>
<span class="px-3 py-1 bg-primary/10 text-primary text-xs font-semibold rounded-full border border-primary/20">#Alps</span>
<span class="px-3 py-1 bg-slate-100 dark:bg-slate-800 text-slate-500 text-xs font-semibold rounded-full flex items-center gap-1 border border-slate-200 dark:border-slate-700">
<span class="material-symbols-outlined text-[14px]">add</span>
                                            Add Tag
                                        </span>
</div>
</div>
</div>
<!-- Footer Actions -->
<div class="p-6 border-t border-slate-100 dark:border-slate-800 flex items-center justify-end gap-3 bg-slate-50/50 dark:bg-slate-900/50 rounded-b-xl">
<button id="ai-location-discard-btn" class="px-4 py-2 text-sm font-bold text-slate-500 hover:text-red-600 transition-colors" type="button">Discard</button>
<button id="ai-location-apply-btn" class="bg-primary hover:bg-primary/90 text-white px-8 py-2.5 rounded-lg font-bold text-sm shadow-md transition-all flex items-center gap-2" type="button">
<span class="material-symbols-outlined text-lg">check</span>
                                    Apply to Form
                                </button>
</div>
</div>
<!-- Preview Image/Map -->
<div class="relative rounded-xl overflow-hidden h-40 border border-slate-200 dark:border-slate-800 shadow-sm group">
<div class="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110" data-alt="Satellite map view of mountain peaks" data-location="Grossglockner Austria" style="background-image: url('https://lh3.googleusercontent.com/aida-public/AB6AXuC7fwHUmmMph4zW94S04HD3v38SfSwdlhEoz7JUhXa0GqLMs5y9TlH3hi_UcqKJzMAREV9DRJV_ebOvcq0Wue6aNEC1tG4nY6vxUYfVK1mN89IRk7O91fNi3E7vk8SH6e_1-2sGGv6JHKlJi0xxKvoM37hr_9V__9dFJbfBHTiACHQaHlJa1cBIFw3ciqWEkLeLQwpGq4B1KMTzZsToBOMPFKfU4g3QvHW92M3CLaNbWeenxCXKu7TXA2riKfBZk9pRXwrrrEp7u5sA')"></div>
<div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
<div class="absolute bottom-4 left-4 flex items-center gap-2 text-white">
<span class="material-symbols-outlined text-lg">map</span>
<span class="text-sm font-bold">Location Verified on Map</span>
</div>
</div>
</div>
</div>
</div>
</div>
<!-- Sticky Footer for small screens or main actions -->
<footer class="h-14 border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-background-dark px-8 flex items-center justify-between lg:hidden">
<button class="text-slate-500 text-sm font-bold">Cancel</button>
<button class="bg-primary text-white px-4 py-2 rounded-lg font-bold text-sm">Generate</button>
</footer>
</main>
</div>
<!-- AI Loading State Overlay (Hidden by default, used for reference) -->
<div id="ai-location-loading" class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center hidden">
<div class="bg-white dark:bg-slate-900 rounded-2xl p-8 shadow-2xl flex flex-col items-center gap-4 max-w-sm text-center">
<div class="relative">
<div class="w-12 h-12 border-4 border-primary/20 border-t-primary rounded-full animate-spin"></div>
<span class="material-symbols-outlined absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-primary">auto_awesome</span>
</div>
<div>
<h4 class="text-lg font-bold">Analyzing Content</h4>
<p class="text-sm text-slate-500 mt-1">Our AI is extracting location metadata and coordinates from your input...</p>
</div>
</div>
</div>
`;
